export const homeContent = {
  hero: {
    title: "A Seat for the Soil at the Big Business Table",
    subheadline: "Money may grow on trees but the soil is where the value stems from",
    description: "Earth Rights Business is a movement of consumers using art and blockchain to fund soil regeneration. Your purchase speaks for the Earth."
  },
  problem: {
    title: "Art That Speaks for the Soil",
    text: "ERB creates collectible alphabet art—digital and physical—that does more than decorate. Each piece you own is a voice in a growing movement to regenerate Earth's soil.\n\n• Join a movement funding soil regeneration\n• Own first-edition collectible art (limited supply)\n• Become part of the founding community\n• Support the creation of a regenerative business certification",
    quote: "NFT — 0.23 SOL | Digital art on Solana blockchain\nPhysical — $55 | Laser-cut wooden art piece"
  },
  invitation: {
    title: "The Soil Cycle of Value",
    quote: "The earth is the ground—you provide the liquidity.",
    description: "1. YOU COLLECT: Purchase alphabet art. Each piece is your stake in the movement. \n2. THE MOVEMENT GROWS: More collectors = stronger voice = greater impact. \n3. SOIL REGENERATES: Resources flow to regenerative farms and certified businesses.",
    items: [
       { title: "Financial Unity", desc: "Soil As Decentralized Instrument" },
       { title: "Spirit & Soil", desc: "Centralized in Purpose" }
    ]
  },
  assetsPreview: {
    title: "Where We're Going",
    subtitle: "PHASE 1: BUILD THE MOVEMENT ← We are here"
  },
  closing: {
    quote: "It is guaranteed that you will one day make soil. But will you afford yourself the privilege to stand on it?",
    description: "This is the beginning. Join the founding movement."
  }
};